import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './Relationships.scss';

export const OnboardingReplikaRelationships: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Relationships',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage className="onboarding-relationships">
      <IonContent>
        <div className="img-container">
          <img
            src={AI_DATA[webCampaign.aiType].relationships.imageSrc}
            alt="relationships"
          />
        </div>
        <OnboardingTitle className="onboarding-relationships__title">
          Build relationships 🔥
        </OnboardingTitle>
        <OnboardingSubtitle>
          Strengthen your bond with characters and earn exciting rewards at each
          level
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
